module.exports = __webpack_public_path__ + "static/media/greenery.91343291.jpg";